var _excluded = ["action", "by", "children", "date", "dateFormat"];

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import fecha from 'fecha';
import React from 'react';
import Col from "../Layout/Col";
import Row from "../Layout/Row";
import ListGroupItem from "../List/ListGroupItem";
/**
 * Extension to Bootstrap [ListGroupItem](https://getbootstrap.com/docs/4.3/components/list-group-item/)
 * representing a timeline event.
 */

var Activity = function Activity(_ref) {
  var action = _ref.action,
      by = _ref.by,
      children = _ref.children,
      date = _ref.date,
      _ref$dateFormat = _ref.dateFormat,
      dateFormat = _ref$dateFormat === void 0 ? 'MM/DD/YYYY hh:mm A' : _ref$dateFormat,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(ListGroupItem, props, /*#__PURE__*/React.createElement(Row, {
    className: "w-100 gx-0 align-items-center"
  }, /*#__PURE__*/React.createElement(Col, {
    className: "me-2 px-0",
    style: {
      maxWidth: '11em'
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "d-inline js-date"
  }, fecha.format(date, dateFormat))), /*#__PURE__*/React.createElement("div", {
    className: "w-100 d-xs-block d-sm-none"
  }), /*#__PURE__*/React.createElement(Col, {
    className: "js-action"
  }, (action || date) && /*#__PURE__*/React.createElement("div", null, action && /*#__PURE__*/React.createElement("strong", null, action), by && /*#__PURE__*/React.createElement("span", {
    className: "ps-1 js-by"
  }, action ? '– ' : '', /*#__PURE__*/React.createElement("span", null, by))), children)));
};

Activity.displayName = "Activity";
Activity.displayName = 'Activity';
export default Activity;